<div class="modal-header">
  <h4 class="modal-title">Duplicate Event Type</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body pb-0">
  <div class="form-group">
    <label for="nameInput">
      New Event Type Name
    </label>
    <input type="text" class="form-control"
           name="nameInput" id="nameInput"
           [(ngModel)]="name">
  </div>

  <div class="alert alert-info">
    The "{{ eventType.name }}" event type and its associated configuration (pricing matrices, attendee questions, etc) will be copied. The new event type will be created in the "Draft" state.
    <br>
    Occurrences, schedules, and schedule exceptions will <b>not</b> be copied.
  </div>

  <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary"
          *ngIf="!loadingSubmit"
          (click)="handleSubmit()">
    Duplicate
  </button>
  <button type="button" class="btn btn-primary disabled" disabled
          *ngIf="loadingSubmit">
    Loading...
  </button>
</div>
